import {initializeApp} from "firebase/app";
import {getAuth} from "firebase/auth";

// YOUR WEB APP'S FIREBASE CONFIGURATION
const firebaseConfig = {
	  apiKey: "AIzaSyDUbbBnACOFYMldR8TiVdEuH4wPiA2Sbfk",
	  authDomain: "apxlaunchpad.firebaseapp.com",
	  projectId: "apxlaunchpad",
	  storageBucket: "apxlaunchpad.appspot.com",
	  messagingSenderId: "228763913025",
	  appId: "1:228763913025:web:4c204c8e07a9def6aaafc0"
};


export const firebaseApp = initializeApp(firebaseConfig);

export const auth = getAuth(firebaseApp);

